export class ArrayIdCombiner {
    static removeDuplicates(arr: any[], idsPresent: string[]) {
        const seen = new Set(idsPresent);
        const result = arr.filter(item => {
            const duplicate = seen.has(item.itemId);
            return !duplicate;
          });
          
          return result;
    }
}